import { useEffect } from 'react'
import { useBucket } from '@mc/experiments-react'
import { trackExperimentViewed } from '@mc/track-event'

// https://app.growthbook.io/features/com-839
const FLAG = 'com-839'

export const useTurnstile = () => {
  useEffect(() => {
    trackExperimentViewed(FLAG)
  }, [])
  return useBucket<'variant_1'>(FLAG)
}
